"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _GameMenu = _interopRequireDefault(require("./GameMenu"));

var _UserMenu = _interopRequireDefault(require("./UserMenu"));

var _ProductTitle = _interopRequireDefault(require("../TitlesAndTexts/ProductTitle"));

var _GlobalMenu = _interopRequireDefault(require("./GlobalMenu"));

var _Searchbox = _interopRequireDefault(require("./Searchbox"));

var _PublishingServicesAvatar = _interopRequireDefault(require("../ImagesAndIcons/PublishingServicesAvatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint object-curly-newline: ["error", { "ObjectExpression": "always" }] */
// Components
// Contents
const HeaderStyled = _styledComponents.default.header.withConfig({
  displayName: "GlobalNavigationV2__HeaderStyled",
  componentId: "design-system__sc-1hcx9mw-0"
})(["box-sizing:border-box;display:grid;grid-template-columns:56px 172px auto 208px 64px 56px 48px;grid-template-areas:'icon logo menu search settings user .';position:sticky;width:100%;background:#fff;height:4.5rem;z-index:101;border-bottom:1px solid ", ";& > *{box-sizing:border-box;}& > .icon{grid-area:icon;display:flex;align-items:center;padding-bottom:5px;margin-left:1.5rem;& > svg{display:block;width:24px;height:28px;}}& > div{display:flex;align-items:center;}& > .logo{grid-area:logo;}& > .menu{grid-area:menu;}& > .search{grid-area:search;}& > .settings{grid-area:settings;}& > .user{grid-area:user;}"], _BaseTheme.default.colors.lightgray);

const GlobalNavigationV2 = _ref => {
  let {
    title,
    titleLink,
    config,
    allPath,
    allPathOnClick,
    games,
    gameSlug,
    logout
  } = _ref;
  const {
    global,
    settings,
    user,
    action,
    search
  } = config;
  return /*#__PURE__*/_react.default.createElement(HeaderStyled, {
    className: "globalnav"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_PublishingServicesAvatar.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/_react.default.createElement(_ProductTitle.default, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: titleLink
  }, title))), /*#__PURE__*/_react.default.createElement("div", {
    className: "menu"
  }, /*#__PURE__*/_react.default.createElement(_GameMenu.default, {
    label: "All Games",
    options: games,
    slug: gameSlug,
    allPath: allPath,
    allPathOnClick: allPathOnClick
  }), /*#__PURE__*/_react.default.createElement(_GlobalMenu.default, {
    menu: global,
    action: action
  })), search && /*#__PURE__*/_react.default.createElement("div", {
    className: "search"
  }, /*#__PURE__*/_react.default.createElement(_Searchbox.default, {
    placeholder: search.placeholder,
    path: search.path,
    value: search.value
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "settings"
  }, /*#__PURE__*/_react.default.createElement(_GlobalMenu.default, {
    menu: settings,
    icon: "settings"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "user"
  }, /*#__PURE__*/_react.default.createElement(_UserMenu.default, {
    imageUrl: user.picture,
    email: user.email,
    logout: logout
  })));
};

GlobalNavigationV2.propTypes = {
  title: _propTypes.default.string.isRequired,
  titleLink: _propTypes.default.string,
  gameSlug: _propTypes.default.string.isRequired,
  logout: _propTypes.default.func,
  allPath: _propTypes.default.oneOfType([_propTypes.default.any]),
  allPathOnClick: _propTypes.default.func,
  games: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    to: _propTypes.default.oneOfType([_propTypes.default.any]),
    appIcon: _propTypes.default.string
  })),
  config: _propTypes.default.shape({
    global: _propTypes.default.arrayOf(_propTypes.default.object),
    search: _propTypes.default.shape({
      path: _propTypes.default.string,
      value: _propTypes.default.string,
      placeholder: _propTypes.default.string
    }),
    action: _propTypes.default.shape({
      path: _propTypes.default.string,
      title: _propTypes.default.string
    }),
    settings: _propTypes.default.arrayOf(_propTypes.default.object),
    user: _propTypes.default.shape({
      picture: _propTypes.default.string,
      email: _propTypes.default.string
    })
  })
};
GlobalNavigationV2.defaultProps = {
  titleLink: '/',
  config: undefined,
  logout: undefined,
  games: undefined,
  allPath: '/',
  allPathOnClick: null
};
var _default = GlobalNavigationV2;
exports.default = _default;